import { useNextRouter } from '@/data/Content/_NextRouter';

export const useCurrentRoute = () => {
	const router = useNextRouter();

	return router.asPath;
};
